<template>
  <div
    class="productBuyBar"
    :class="{ productBuyBarOpen: productBuyOptionVisibility }"
  >
    <div class="productBuyBarDeco">
      <transition name="slide-fade">
        <button
          v-if="product.productStatus === 2"
          type="button"
          class="btBuy button11"
          v-show="!productBuyOptionVisibility"
          @click="productBuyOptionToggle"
        >
          {{ product.type === 7 ? '응모하기' : '구매하기' }}
        </button>
        <button v-else type="button" class="btBuy button12" disabled="disabled">
          {{ productStatusNotSale }}
        </button>
      </transition>
      <!-- existSelectedCharacter ? selectedCharacter.gcName : -->
      <transition name="slide-fade">
        <div
          class="productBuyOption"
          v-show="productBuyOptionVisibility && product.productStatus === 2"
        >
          <dl
            v-if="isInpayPayment && !existSelectedCharacter"
            class="productBuyCharacter notExistSelectedCharacter"
          >
            <dt>구매캐릭터</dt>
            <dd
              class="inpayCharacterButtonNotSelected"
              @click="handleClickCharacterSetting"
            >
              캐릭터 설정
              <img src="../../assets/images/ico_arrow.png" />
            </dd>
          </dl>
          <div
            v-if="isInpayPayment && existSelectedCharacter"
            class="productBuyCharacter"
          >
            <div style="display: flex; flex-direction: column;">
              <span class="productBuyCharacterTitle">구매 캐릭터</span>
              <div
                style="display: flex; flex-direction: row; justify-content: space-between; align-items: center; margin-top: 10px;"
              >
                <span class="characterName">
                  {{ selectedCharacter.gcName }}
                </span>
                <div
                  class="inpayCharacterButton"
                  style="align-self: center;"
                  @click="handleClickCharacterSetting"
                >
                  캐릭터 설정
                  <img
                    class="inpayCharacterButtonImage"
                    src="../../assets/images/ico_arrow_black.png"
                  />
                </div>
              </div>
              <span class="characterInfo" style="display:flex;">
                <span>{{ selectedCharacter.worldName }}</span>
                <span class="bar"></span>
                <span>Lv. {{ selectedCharacter.gcLevel }}</span>
                <span class="bar"></span>
                <span>{{ selectedCharacter.gcClass }}</span>
              </span>
            </div>
          </div>
          <dl class="productBuyOptionForm">
            <dt :class="{ alltem: isInpayPayment }">수량선택</dt>
            <dd :class="{ alltem: isInpayPayment }">
              <form-select-amount
                :quantity="quantity"
                @handleQuantity="handleQuantity"
              ></form-select-amount>
            </dd>
          </dl>
          <div class="productBuyOptionView">
            <dl
              :class="{
                productBuyOptionAmount: true,
                optionview_dl: !isInpayPayment
              }"
            >
              <dt>총 수량</dt>
              <dd>
                <span>{{ quantity }}</span>
                개
              </dd>
            </dl>
            <dl
              :class="{
                productBuyOptionPrice: true,
                optionview_dl: !isInpayPayment
              }"
            >
              <dt>총 금액</dt>
              <dd>
                {{ (quantity * product.price).addComma()
                }}{{ product.currencyUnit }}
              </dd>
            </dl>
          </div>
          <button
            v-if="enableCart && product.type !== 3 && product.type !== 4"
            type="button"
            class="btCart button52"
            @click="handleClickAddCart"
          >
            장바구니 담기
          </button>
          <!-- <div v-if="isInpayPayment" class="cart_character"></div> -->
          <button
            type="button"
            class="btbuy"
            :class="
              !enableCart || product.type === 3 || product.type === 4
                ? 'button14'
                : 'button51'
            "
            @click="handleClickBuy"
          >
            {{ product.type === 7 ? '바로 응모하기' : '바로 구매하기' }}
          </button>
          <button type="button" class="btClose" @click="productBuyOptionToggle">
            <span class="icon iconDown"></span>
            <span class="accessibilityHide">수량선택창 닫기</span>
          </button>
        </div>
      </transition>
    </div>
  </div>
</template>

<script>
import FormSelectAmount from '@/views/base/FormSelectAmount'
import { mapActions, mapGetters } from 'vuex'
import {
  isLogin,
  goToLoginPage,
  loginCheckWrap,
  beforeSendLog,
  convertProductStatusToKor,
  checkCountLimit
} from '@/utils'
import inpayError from '@/utils/inpayError'
import PaymentAPI from '@/api/payment'

export default {
  name: 'ProductBuyBar',
  components: {
    FormSelectAmount
  },
  props: {
    product: {
      type: Object,
      default: () => {
        return {}
      }
    },
    fundingAgree: {
      type: Boolean,
      default: false
    }
  },
  watch: {
    product: {
      handler(n, o) {
        if (n) {
          this.quantity = 1
          this.productBuyOptionVisibility = false
        }
      }
    },
    needOpenInpay(n, o) {
      if (n) {
        const popupWindow = this.inpayHandler.start()

        this.openModal({
          type: 'alert',
          message: '결제창에서 구매를 완료해주세요',
          callback: () => {},
          noFooter: true,
          showFooterInSecond: 3
        })

        this.inpayInterval = setInterval(() => {
          if (popupWindow.closed && this.inpayHandler.status === 'PAYMENT') {
            if (this.inpayHandler) {
              this.inpayHandler.cancel()
            }
            clearInterval(this.inpayInterval)
          }
        }, 1000)
      }
    }
  },
  computed: {
    ...mapGetters('main', ['enableCart', 'paymentSystemType', 'shopId']),
    ...mapGetters('character', ['selectedCharacter']),
    productStatusNotSale() {
      return convertProductStatusToKor(this.product.productStatus)
    },
    isInpayPayment() {
      return this.paymentSystemType === 3
    },
    existSelectedCharacter() {
      return !Object.values(this.selectedCharacter).every(
        value => value === null || value === 0
      )
    }
  },
  data() {
    return {
      productBuyOptionVisibility: false,
      quantity: 1,
      inpayHandler: null,
      inpayInterval: null,
      needOpenInpay: false
    }
  },
  mounted() {
    if (this.isInpayPayment) {
      this.getSelectedCharacter()
    }
  },
  beforeDestroy() {
    if (this.inpayHandler) {
      this.inpayHandler = null
    }

    clearInterval(this.inpayInterval)
  },
  methods: {
    ...mapActions('cart', ['addProductOfCart']),
    ...mapActions('modal', ['openModal', 'closeModal']),
    ...mapActions('character', ['getSelectedCharacter']),
    productBuyOptionToggle: function() {
      if (isLogin()) {
        if (this.product.type === 4 && !this.fundingAgree) {
          // [상품상세] 프론트에서 펀딩 종료를 판단하면, 목표 초과 달성은 존재할 수 없는 것?
          // 확인 후 조건 변경
          this.openModal({
            type: 'confirm',
            message: `구매 시 유의사항을 체크해주세요.`
          })
        } else {
          this.productBuyOptionVisibility = !this.productBuyOptionVisibility
          if (this.productBuyOptionVisibility === true) {
            beforeSendLog('Buy', { ProductType: this.product.type })
          }
        }
      } else {
        goToLoginPage()
      }
    },
    handleClickCharacterSetting() {
      if (isLogin()) {
        beforeSendLog('CharacterSetting', { ShopID: this.shopId })
        this.$router.push({
          name: 'characters'
        })
      } else {
        goToLoginPage()
      }
    },
    handleQuantity(quantity) {
      const newQuantity = this.quantity + quantity
      if (
        checkCountLimit(newQuantity, this.product) &&
        newQuantity > 0 &&
        newQuantity <= 10
      ) {
        this.quantity += quantity
      }
    },
    handleClickAddCart() {
      beforeSendLog('AddCart', { ProductID: this.product.productId })
      this.addProductOfCart({ ...this.product, purchaseCount: this.quantity })
    },
    handleClickBuy() {
      // inpay 이면서 캐릭터 설정이 안되어있다면 pass 시켜야함
      if (this.paymentSystemType === 3) {
        if (!this.existSelectedCharacter) {
          this.openModal({
            type: 'alert',
            message: `죄송합니다. <br> 상품을 구매할 캐릭터가 없습니다. <br> 캐릭터를 설정 후 다시 시도해주세요.`,
            canCancel: true,
            confirmText: '캐릭터 설정하기',
            callback: () => {
              this.$router.push({
                name: 'characters'
              })
            }
          })
          return
        }

        this.requestInpay(this.selectedCharacter)
      } else {
        beforeSendLog('Order', { ProductID: this.product.productId })
        // 구매 가능 회원인지 확인
        loginCheckWrap(() => {
          const newProduct = {
            ...this.product,
            purchaseCount: this.quantity,
            paymentSystemType: this.paymentSystemType
          }

          // mark: test code
          // beforeSendLog('Order')
          // this.$router.push({
          //   name: 'order',
          //   params: {
          //     fromView: true,
          //     productList: [newProduct]
          //   }
          // })

          PaymentAPI.checkPolicyProduct(newProduct, ({ code }) => {
            if (code === 0) {
              beforeSendLog('Order', { ProductID: this.product.productId })
              this.$router.push({
                name: 'order',
                params: {
                  fromView: true,
                  productList: [newProduct]
                }
              })
            }
          })
        })
      }
    },
    async requestInpay({ gid, gcid, worldId, gsid }) {
      // 각 id type은 string임
      inface.inpay.initialize({ env: process.env.VUE_APP_INFACE_ENV })

      const pid = this.product.pid
      const packageIndex = this.product.packageIndex

      const bilingParam = {
        productId: pid,
        stampEnv: process.env.VUE_APP_STAMP_ENV, // stamp 연결 환경을 지정하기 위한 환경 값.  live, qa, alpha 값이 존재
        market: 'krpc', // 현재 KRPC만 지원합니다.
        gid,
        gsid, // (옵션) 결제시 아이템 지급을 플랫폼 계정이 아니라 게임의 캐릭터 단위로 지급할 때 필요한 정보
        gcid, // (옵션) 결제시 아이템 지급을 플랫폼 계정이 아니라 게임의 캐릭터 단위로 지급할 때 필요한 정보
        worldId, // (옵션) 결제시 아이템 지급을 플랫폼 계정이 아니라 게임의 캐릭터 단위로 지급할 때 필요한 정보
        inflowPath: 'nxshop',
        quantity: this.quantity, // (옵션) 다수구매 가능한 multiQuantityEnabled 값이 true인 경우 구매할 개수를 추가로 입력합니다.

        onChangeStatus: (status, fail_reason) => {
          if (status === 'FAIL') {
            this.openModal({
              type: 'alert',
              message: fail_reason,
              callback: () => {}
            })
          }

          if (status === 'CANCEL') {
            this.openModal({
              type: 'alert',
              message: '결제가 취소되었습니다.',
              callback: () => {},
              noFooter: false
            })
          }

          if (status === 'PAYMENT_COMPLETED') {
            this.openModal({
              type: 'alert',
              message: '결제가 완료되었습니다.',
              callback: () => {},
              noFooter: false
            })
          }

          clearInterval(this.inpayInterval)
        }
      }

      if (packageIndex) {
        bilingParam.gameMeta = { packageIndex }
      }

      // ux 새창 확인
      this.inpayHandler = await inface.inpay.billingPurchase(bilingParam)
      if (!!this.inpayHandler && !!this.inpayHandler.error) {
        const errorMessage =
          inpayError[this.inpayHandler.error_code] || inpayError.default

        this.openModal({
          type: 'alert',
          message: `${errorMessage}${
            !!this.inpayHandler.error_code
              ? `<br><div style="font-size:10px">[에러코드: ${
                  this.inpayHandler.error_code
                }]</div>`
              : ''
          }`,
          callback: () => {}
        })
      } else {
        this.openInpay()
      }
    },
    openInpay() {
      const popupWindow = this.inpayHandler.start()

      this.openModal({
        type: 'alert',
        message:
          '결제창에서 구매를 완료해주세요<br><br><div style="color:#808080;font-size:13px">결제창으로 넘어가지 않는 경우,<br>브라우저 설정에서 팝업 차단을 해제하고<br>다시 시도해 주세요</div>',
        callback: () => {},
        noFooter: true,
        showFooterInSecond: 3
      })

      this.inpayInterval = setInterval(() => {
        if (popupWindow.closed && this.inpayHandler.status === 'PAYMENT') {
          if (this.inpayHandler) {
            this.inpayHandler.cancel()
          }
          clearInterval(this.inpayInterval)
        }
      }, 1000)
    }
  }
}
</script>

<style lang="scss">
.productBuyBar {
  width: 100%;
  // height: 55px; safeArea
  .productBuyBarDeco {
    position: fixed;
    bottom: 0;
    left: 0;
    width: 100%;
    // height: 55px; safeArea
    background-color: #fff;
    z-index: 100;
  }
  .btBuy {
    position: absolute;
    top: 0;
    left: 0;
  }
  .productBuyOption {
    position: absolute;
    bottom: 0;
    left: 0;
    width: 100%;
    // height: 171px; safeArea
    border-top: 1px solid #13151f;
    background-color: #fff;
    box-shadow: 0 -1px 1px 0 rgba(21, 23, 33, 0.25);
  }
  .slide-fade-enter-active {
    z-index: 10;
  }
  .slide-fade-leave-active {
    z-index: 1;
  }
  .slide-fade-enter-active,
  .slide-fade-leave-active {
    transition: all 0.5s cubic-bezier(0.19, 1, 0.22, 1);
  }
  .slide-fade-enter,
  .slide-fade-leave-to {
    transform: translateY(100%);
    opacity: 0;
  }
  .productBuyOptionForm {
    height: 56px;
    padding: 0;
    font-family: 'Noto Sans KR';
    // padding-right: 16px; safeArea
    // padding-left: 16px; safeArea
    dt {
      display: inline-block;
      width: 30%;
      padding-top: 22px;
      font-size: 13px;
    }
    dd {
      display: inline-block;
      width: 70%;
      padding-top: 12px;
      text-align: right;
      vertical-align: top;
    }
    .alltem {
      border-top: 1px solid #d6d6db;
    }

    .alltem {
      border-top: 1px solid #d6d6db;
    }
  }
  .productBuyOptionView {
    padding: 0;
    // padding-left: 16px; safeArea
    // padding-right: 16px; safeArea
    font-size: 12px;
    font-family: 'Noto Sans KR';
    dl {
      display: inline-block;
      width: 50%;
      height: 59px;
      vertical-align: bottom;
    }
    .optionview_dl {
      border-top: 1px solid #d6d6db;
    }
    dt,
    dd {
      display: inline-block;
      vertical-align: top;
    }
  }
  .productBuyCharacter {
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    padding: 18px 16px 18px 16px;
    font-family: 'Noto Sans KR';

    .productBuyCharacterTitle {
      font-size: 13px;
      color: #151721;
    }
    .characterName {
      font-size: 15px;
      color: #6134f1;
      font-weight: bold;
    }
    .inpayCharacterButtonNotSelected {
      cursor: pointer;
      font-size: 13px;
      color: #6134f1;
      font-weight: bold;
    }
    .inpayCharacterButton {
      cursor: pointer;
      font-size: 13px;
      color: #57575c;
    }
    .inpayCharacterButtonImage {
      width: 8px;
      height: 11px;
    }
    .characterInfo {
      margin-top: 5px;
      font-size: 13px;
      color: #636376;
      .bar {
        display: inline-block;
        width: 1px;
        height: 12px;
        margin: 0 6px;
        background-color: #a5a5ac;
      }
    }
    dt {
      display: inline-block;
      width: 30%;
      padding-top: 22px;
      font-size: 13px;
      color: #151721;
    }
    dd {
      display: inline-block;
      width: 70%;
      padding-top: 22px;
      text-align: right;
      vertical-align: top;
      font-size: 13px;
      color: #57575c;
    }
    .icon_arrow {
      background: url('../../assets/images/ico_arrow.png') no-repeat 0 0;
      background-size: 100px;
    }
  }

  .productBuyCharacter.notExistSelectedCharacter {
    display: block;
    padding: 0 16px 18px 16px;
  }

  .productBuyOptionAmount {
    padding-top: 23px;
    font-size: 13px;
    dt {
      padding-right: 5px;
    }
    span {
      font-weight: bold;
    }
  }
  .productBuyOptionPrice {
    text-align: right;
    dt {
      padding: 25px 17px 0 0;
      color: #636376;
    }
    dd {
      padding-top: 21px;
      font-size: 18px;
      color: #6134f1;
    }
  }
  .btMinus,
  .btPlus {
    width: 31px;
    height: 31px;
    border: 1px solid #bcbcc0;
    vertical-align: top;
  }
  .inputAmount {
    width: 45px;
    height: 31px;
    font-size: 15px;
    font-weight: bold;
    text-align: center;
    border-top: 1px solid #bcbcc0;
    border-bottom: 1px solid #bcbcc0;
    vertical-align: top;
  }
  .btClose {
    position: absolute;
    top: -26px;
    left: 50%;
    width: 42px;
    height: 26px;
    margin-left: -21px;
    border: 1px solid #13151f;
    border-bottom-width: 0;
    background-color: #fff;
    box-shadow: 0 2px 0 0 rgba(255, 255, 255, 1),
      0 -1px 1px 0 rgba(21, 23, 33, 0.25);
  }
  .cart_character {
    width: 50%;
    height: 55px;
  }
}
@media screen and (min-width: 1024px) {
  .productBuyBarDeco {
    width: 1024px !important;
    left: 50% !important;
    transform: translateX(-50%) !important;
  }
}
</style>
